"use strict";
/**************************************************************************************************
 *
 *       @file ./javelin-manager.ts
 *
 *       Applies typings to JavelinManager object bundled in transpiled Javelin output
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
var shared_1 = require("mad-utils/lib/shared");
var javelin_exports_1 = require("../../javelin-exports");
var delegation_1 = require("../../util/delegation");
/******************************************** LOGGING *********************************************/
var shared_2 = require("mad-logs/lib/shared");
var log = shared_2.logFactory('javelin-manager.ts', shared_2.Styles.joy);
/********************************* EXPORT DATA WITH TYPES APPLIED *********************************/
exports.JavelinManager = javelin_exports_1.javelin.JavelinManager;
shared_1.defineProp(exports.JavelinManager.prototype, 'JVLN_CLASS_NAME', 'JavelinManager', false);
// Dispatcher for logMessage vs logError
shared_1.defineProp(exports.JavelinManager.prototype, 'log', function javelinManagerLog(tag, msgOrException) {
    return typeof msgOrException === 'string'
        ? this.logMessage(tag, msgOrException)
        : this.logError(tag, msgOrException);
});
/***************************************** FACTORY EXPORT *****************************************/
/**
 * Builds JavelinManager
 * Properly handles lateinit props
 * Binds instance to Companion object
 */
exports.javelinManagerFactory = function javelinManagerFactory(platform, javelinImpl, javelinJson, javelinDate, javelinData) {
    new exports.JavelinManager(platform, javelinImpl, javelinJson, javelinDate, javelinData);
    var javelinManager = delegation_1.instantiateAndBindToLateinit.apply(void 0, [exports.JavelinManager].concat(Array.from(arguments)));
    // Bind instance to actual class (singleton)
    exports.JavelinManager.Companion.instance = javelinManager;
    return javelinManager;
};
//# sourceMappingURL=javelin-manager.js.map